import { isString } from "util";

export default {
    data() {
        return {
            sort_key: null,
            sort_dir: 1,
        }
    },

    methods: {
        sortClass(key) {
            const classname = 'sortable';
            if (this.sort_key !== key) {
                return classname;
            }

            return classname + ' ' + (this.sort_dir ? 'sort-up' : 'sort-down');
        },

        sortItems(key, items) {
            let sorted = items.slice(0);
            sorted = sorted.sort((a, b) => {
                let valA =  a[key];
                let valB =  b[key];
                if (typeof valA == 'undefined') {
                    valA = 0;
                }
                if (typeof valA == 'number' || !isNaN(valA)) {
                    valA = parseFloat(valA);
                } else if (isString(valA)) {
                    valA = valA.toLowerCase();
                }

                if (typeof valB == 'undefined') {
                    valB = 0;
                }
                if (typeof valB == 'number' || !isNaN(valB)) {
                    valB = parseFloat(valB);
                } else if (isString(valB)) {
                    valB = valB.toLowerCase();
                }

                if (valA > valB) {
                    return -1;
                }
                if (valB > valA) {
                    return 1;
                }
                return 0;
            });

            if (this.sort_key === key) {
                this.sort_dir = !this.sort_dir;
            } else {
                this.sort_dir = 1;
            }

            if (!this.sort_dir) {
                sorted = window._.reverse(sorted);
            }

            this.sort_key = key;

            return sorted;

        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Sortables.js